import PlayIcon from '../assets/icons/play.svg';
import SendIcon from '../assets/icons/send.svg';
import SearchIcon from '../assets/icons/search.svg';
import UploadIcon from '../assets/icons/upload.svg';
import HeartIcon from '../assets/icons/heart.svg';
import locationIcon from '../assets/icons/location.svg';
import FacebookIcon from '../assets/icons/facebook.svg';
import InstagramIcon from '../assets/icons/instagram.svg';
import TwitterIcon from '../assets/icons/twitter.svg';
import PauseRedIcon from '../assets/images/pause_red.svg';
import PlayRedIcon from '../assets/images/play_red.svg';
import LinearHeartIcon from '../assets/icons/linear_heart.svg';
import ShareWhiteIcon from '../assets/icons/share_white.svg';
import ArrowDownIcon from '../assets/icons/chevronDown.svg';
import CloseWhiteIcon from '../assets/icons/close_wt.svg';
import LinearHeartFilledIcon from '../assets/icons/linear_heart_filled.svg';
const icons = {
  play: PlayIcon,
  pauseRed: PauseRedIcon,
  playRed: PlayRedIcon,
  send: SendIcon,
  search: SearchIcon,
  upload: UploadIcon,
  heart: HeartIcon,
  location: locationIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  twitter: TwitterIcon,
  shareWhite: ShareWhiteIcon,
  linearHeart: LinearHeartIcon,
  arrowDown: ArrowDownIcon,
  closeWhite: CloseWhiteIcon,
  linearHeartFilled: LinearHeartFilledIcon,
};

export default icons;